var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalcFigureVolumeSphere(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 250 250",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "Artboard1",
    x: 0,
    y: 0,
    width: 250,
    height: 250,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Artboard11"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-5,20.4607)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 145,
    cy: 99,
    r: 85,
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: 4
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.493333,0,0,1,96.8333,-0.539346)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 87.5,
    cy: 120,
    rx: 37.5,
    ry: 85,
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "1.27px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.79655e-17,-0.456711,1,6.12323e-17,20,159.423)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 87.5,
    cy: 120,
    rx: 37.5,
    ry: 85,
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "1.29px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(8.82956e-17,-1.44198,1,6.12323e-17,20,245.634)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 87.5,
    cy: 120,
    rx: 37.5,
    ry: 85,
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "0.81px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.143e-16,-1.86667,1,6.12323e-17,20,282.794)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 87.5,
    cy: 120,
    rx: 37.5,
    ry: 85,
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "0.67px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.43333,0,0,1,13.3333,-0.539346)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 87.5,
    cy: 120,
    rx: 37.5,
    ry: 85,
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "0.81px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.96,0,0,1,-31.5,-0.539346)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 87.5,
    cy: 120,
    rx: 37.5,
    ry: 85,
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "0.64px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.967528,0,0,0.967528,57.6781,54.8475)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "78.3px",
    y: "36.332px",
    style: {
      fontFamily: "'AndaleMono', 'Andale Mono', monospace",
      fontSize: "18.119px"
    }
  }, "V")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.391018,-0.391018,0.173843,0.173843,56.8992,168.616)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.673,106.4L33.673,121.324L15.98,101.425L33.673,81.527L33.673,96.451L167.431,96.451L167.431,81.527L167.431,121.324L167.431,106.4L33.673,106.4Z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.967528,0,0,0.967528,21.4521,114.847)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "78.3px",
    y: "36.332px",
    style: {
      fontFamily: "'AndaleMono', 'Andale Mono', monospace",
      fontSize: "18.119px"
    }
  }, "r"))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalcFigureVolumeSphere);
export default __webpack_public_path__ + "static/media/calc-figure-volume-sphere.df5ca0dc87ea03c3a5dece0ccde5d13f.svg";
export { ForwardRef as ReactComponent };